import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import TreatmentForm from 'Component/DashboardQeza/Treatment/Form';
import { getTreatment } from 'Services/Features/Treatment/Utils/treatmentUtils';
import { setFormData, resetFormData } from 'Services/Features/Treatment/treatmentSlice';

const TreatmentAdd = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const filters = useSelector(state => state.treatment.filters)
    const currentTreatment = useSelector((state) => state.treatment.currentTreatment);
    const [refetch, setRefetch] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        if (id) {
            // Buat filter untuk ambil data berdasarkan ID
            const newFilters = {
                ...filters,
                "filter[id]": id,
                page: 1,
            };

            // Fetch data dari API pakai ID
            dispatch(getTreatment(newFilters)).then((response) => {
                if (response.payload && response.payload.data?.length > 0) {
                    const item = response.payload.data[0]; // Ambil item pertama (kalau ada)

                    // Simpan photos & banner ke state terpisah
                    dispatch(setFormData({ photosLink: item.photos }));

                    // Buat objek baru tanpa photos & banner
                    const { photos, ...updatedItem } = item;

                    dispatch(setFormData({
                        ...updatedItem,
                        category_id: item.category?.id,
                    }));
                }
            });
        } else if (currentTreatment?.id) {
            // Kalau nggak ada ID, tapi ada data di state, pakai yang ada
            dispatch(setFormData({
                ...currentTreatment,
            }));
        } else {
            // Kalau nggak ada ID & data di state, reset form
            dispatch(resetFormData());
        }
    }, [id, refetch]);



    return (
        <Fragment>
            <Breadcrumbs parent="Perawatan" title={id ? 'Edit Layanan Perawatan' : 'Tambah Layanan Perawatan'} />
            <TreatmentForm label={id ? "" : "Layanan Perawatan Baru"} setRefetch={setRefetch} />
        </Fragment>
    );
};
export default TreatmentAdd;